import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Tabs,
  Tab,
  Box,
  Slide,
  Avatar
} from "@mui/material";
import { Grid } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";
import AuthViewController from "../../redux/actions/AuthViewController";
import BasicDetailEditForm from "./Tabs/BasicDetails";
import EducationDetailEditForm from "./Tabs/EducationDetails";
import ExperienceDetailEditForm from "./Tabs/Experience";
import AccountDetailEditForm from "./Tabs/SalaryDetails";
import EmployerViewController from "../../redux/actions/EmployerApiAction";
import { IMAGE_URL } from "../../services/api";
import { getUserInfoFromToken } from "../../utils/authUtils";
import ProtectedImage from "../../components/ProtectedImage";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const tabLabels = [
  "Basic Detail",
  "Professional Detail",
  "Education Detail",
  "Experiance Detail",
  "Salary Detail",
  "Leave Detail"
];

const EditProfileDialog = ({ open, handleClose }) => {
  const dispatch = useDispatch();
  const { updateEmployee } = EmployeeProfileVeiwController();
  const { updateEmployer } = EmployerViewController();
  const { employee_data } = useSelector((state) => state.employeeProfile);
  const { getUserDetails } = AuthViewController();
  const { userDetails } = useSelector((state) => state.auth);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingAccount, setIsEditingAccount] = useState(false);
  // const userType = localStorage.getItem("user_type");
   const [userType, setUserType] = useState(null);
      const [userId, setUserId] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
      dispatch(getUserDetails());
   
    }, []);

  const handleBasicDetailSave = (values) => {
    const payload = {
      id: userDetails.id,
      first_name: values.first_name,
      last_name: values.last_name,
      email: values.email,
      mobile_number: values.mobile_number,
      gender: values.gender,
      nationality: values.nationality,
      profile: {
        date_of_birth: values.date_of_birth,
        aadhar_number: values.aadhar_number,
        about: values.about,
        address: {
          residentialAddress: values.residentialAddress,
          currentAddress: values.currentAddress
        },
        profile_image: values.profile_image,
        education: values.education || []
      }
    };

    dispatch(updateEmployee(payload.id, payload));

    // Update the local object so the UI reflects changes
    userDetails.first_name = payload.first_name;
    userDetails.last_name = payload.last_name;
    userDetails.email = payload.email;
    userDetails.mobile_number = payload.mobile_number;
    userDetails.gender = payload.gender;
    userDetails.nationality = payload.nationality;
    userDetails.profile_data = payload.profile;

    setIsEditing(false);
  };

  const handleCancelEdit = () => setIsEditing(false);
  const formikRef = useRef();
                        useEffect(() => {
                        const { userType, userId } = getUserInfoFromToken();
                        setUserType(userType);
                        setUserId(userId);
                      }, []);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      hideBackdrop
      PaperProps={{
        sx: {
          width: "80%",
          height: "100vh",
          position: "fixed",
          top: 0,
          right: 0,
          m: 0,
          borderRadius: 0,
          boxShadow: 4,
          overflow: "hidden",
          maxWidth: "none",
          maxHeight: "100%",
        }
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          borderBottom: "1px solid #ccc"
        }}
      >
       <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
  <Avatar sx={{ width: 56, height: 56}}>
    {userDetails?.profile_data?.profile_image ? (
      <ProtectedImage
        path={userDetails.profile_data.profile_image}
        alt={`${userDetails?.first_name || ""} ${userDetails?.last_name || ""}`}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "50%"
        }}
      />
    ) : (
      `${userDetails?.first_name?.[0] || ""}${userDetails?.last_name?.[0] || ""}`
    )}
  </Avatar>

  <Box>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexWrap: "wrap"
      }}
    >
      <Typography variant="h6" fontWeight="bold">
        {userDetails?.first_name} {userDetails?.last_name}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        ({userDetails?.employee_id || "N/A"})
      </Typography>
    </Box>

    <Typography variant="body2" color="text.secondary">
      {userDetails?.profile_data?.designation_name || "N/A"}
    </Typography>
  </Box>
</Box>


        <Box sx={{ flexGrow: 1 }} />

        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Body with Tabs and Content */}
      <DialogContent sx={{ overflowY: "auto", p: 2 }}>
        <Tabs
          value={tabIndex}
          onChange={(e, newValue) => setTabIndex(newValue)}
          indicatorColor="primary"
          textColor="primary"
          // variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: "1px solid #ccc", mb: 2 }}
        >
          {tabLabels.map((label, index) => (
            <Tab key={index} label={label} />
          ))}
        </Tabs>

        {/* Tab Content */}
        {tabIndex === 0 && (
          <Box>
            {/* Title with Edit icon */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
              sx={{ pl: 2 }}
            >
              <Typography variant="h6">Basic Detail</Typography>
              {!isEditing && userType === "Employee" && (
                <EditIcon
                  sx={{ color: "gray", cursor: "pointer" }}
                  onClick={() => setIsEditing(true)}
                />
              )}
            </Box>

            {/* Form or View */}
            {!isEditing ? (
              <Grid container spacing={2} mt={4}>
                <Grid item xs={12} sm={4} md={3}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                   <Avatar
  sx={{ width: 100, height: 100, mb: 1, bgcolor: "primary.main", fontSize: 36 }}
>
  {userDetails?.profile_data?.profile_image ? (
    <ProtectedImage
      path={userDetails.profile_data.profile_image}
      alt={`${userDetails?.first_name || ""} ${userDetails?.last_name || ""}`}
      className="company-logo"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: "50%",
      }}
    />
  ) : (
    <>
      {userDetails?.first_name?.[0]?.toUpperCase() || "N"}
      {userDetails?.last_name?.[0]?.toUpperCase() || "N"}
    </>
  )}
</Avatar>

                    <Typography variant="subtitle1" fontWeight="bold">
                      {userDetails?.first_name} {userDetails?.last_name}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={8} md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Typography>
                        <strong>Email:</strong> {userDetails?.email || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography>
                        <strong>Mobile:</strong>{" "}
                        {userDetails?.mobile_number || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography>
                        <strong>Gender:</strong> {userDetails?.gender || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography>
                        <strong>Nationality:</strong>{" "}
                        {userDetails?.nationality || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography>
                        <strong>Date of Birth:</strong>{" "}
                        {userDetails?.profile_data?.date_of_birth || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography>
                        <strong>Aadhar Number:</strong>{" "}
                        {userDetails?.profile_data?.aadhar_number || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography>
                        <strong>Residential Address :</strong>{" "}
                        {userDetails?.profile_data?.address
                          ?.residentialAddress || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography>
                        <strong>Current Address:</strong>{" "}
                        {userDetails?.profile_data?.address?.currentAddress ||
                          "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography>
                        <strong>About:</strong>{" "}
                        {userDetails?.profile_data?.about || "N/A"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <BasicDetailEditForm
                userDetails={userDetails}
                onCancel={handleCancelEdit}
                onSave={handleBasicDetailSave}
              />
            )}
          </Box>
        )}

        {tabIndex === 1 && (
          <Box sx={{ ml: 2 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography variant="h6">Professional Detail</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Designation:</strong>{" "}
                  {userDetails?.profile_data?.designation_name || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Department:</strong>{" "}
                  {userDetails?.profile_data?.department_name || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Employment Type:</strong>{" "}
                  {userDetails?.profile_data?.employment_type || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Work Location:</strong>{" "}
                  {userDetails?.profile_data?.work_location || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Shift Timing:</strong>{" "}
                  {userDetails?.profile_data?.shift_timing || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Weekly Off:</strong>{" "}
                  {userDetails?.profile_data?.weekly_off || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Working Hours:</strong>{" "}
                  {userDetails?.profile_data?.working_hours || "N/A"}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )}

        {tabIndex === 2 && (
          <Box sx={{ ml: 2 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography variant="h6">Education Detail</Typography>
              {!isEditing && userType === "Employee" && (
                <EditIcon
                  sx={{ color: "gray", cursor: "pointer" }}
                  onClick={() => setIsEditing(true)}
                />
              )}
            </Box>

            {!isEditing ? (
              <Grid container spacing={2}>
                {userDetails?.profile_data?.education?.length > 0 ? (
                  userDetails.profile_data.education.map((edu, index) => (
                    <React.Fragment key={index}>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>College Name:</strong> {edu.name || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>Percentage:</strong> {edu.percentage || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>Passing Year:</strong>{" "}
                          {edu.passingYear || "N/A"}
                        </Typography>
                      </Grid>
                    </React.Fragment>
                  ))
                ) : (
                  <Grid item xs={12}>
                    <Typography>No education details available.</Typography>
                  </Grid>
                )}
              </Grid>
            ) : (
              <EducationDetailEditForm
                userDetails={userDetails}
                onCancel={() => setIsEditing(false)}
                onSave={(payload) => {
                  dispatch(updateEmployee(payload.id, payload));
                  userDetails.profile_data.education =
                    payload.profile.education;
                  setIsEditing(false);
                }}
              />
            )}
          </Box>
        )}

        {tabIndex === 3 && (
          <Box sx={{ ml: 2 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography variant="h6">Experience Detail</Typography>
              {!isEditing && userType === "Employee" && (
                <EditIcon
                  sx={{ color: "gray", cursor: "pointer" }}
                  onClick={() => setIsEditing(true)}
                />
              )}
            </Box>

            {!isEditing ? (
              <Grid container spacing={2}>
                {userDetails?.profile_data?.experience &&
                userDetails.profile_data.experience.length > 0 ? (
                  userDetails.profile_data.experience.map((exp, index) => (
                    <React.Fragment key={index}>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>Company Name:</strong> {exp.company || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>Joining Date:</strong> {exp.joining || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>End Date:</strong> {exp.end || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography>
                          <strong>Designation:</strong>{" "}
                          {exp.designation || "N/A"}
                        </Typography>
                      </Grid>
                    </React.Fragment>
                  ))
                ) : (
                  <Grid item xs={12}>
                    <Typography>No experience details available.</Typography>
                  </Grid>
                )}
              </Grid>
            ) : (
              <ExperienceDetailEditForm
                userDetails={userDetails}
                onCancel={() => setIsEditing(false)}
                onSave={(payload) => {
                  dispatch(updateEmployee(payload.id, payload));
                  userDetails.profile_data.experience =
                    payload.profile.experience;
                  setIsEditing(false);
                }}
              />
            )}
          </Box>
        )}

        {tabIndex === 4 && (
          <Box sx={{ ml: 2 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography variant="h6">Salary Detail</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Basic Salary:</strong> ₹
                  {userDetails?.employee_salary?.basic_salary || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Gross Salary:</strong> ₹
                  {userDetails?.employee_salary?.gross_salary || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Net Salary:</strong> ₹
                  {userDetails?.employee_salary?.net_salary || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Deductions:</strong>
                </Typography>
                {userDetails?.employee_salary?.deductions ? (
                  Object.entries(userDetails.employee_salary.deductions).map(
                    ([key, value], index) => (
                      <Typography key={index} sx={{ ml: 2 }}>
                        {key
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase())}
                        : ₹{value}
                      </Typography>
                    )
                  )
                ) : (
                  <Typography sx={{ ml: 2 }}>N/A</Typography>
                )}
              </Grid>
            </Grid>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
              mt={2}
            >
              <Typography variant="h6">Account Details</Typography>
              {!isEditing && userType === "Employee" && (
                <EditIcon
                  sx={{ color: "gray", cursor: "pointer" }}
                  onClick={() => setIsEditingAccount(true)}
                />
              )}
            </Box>

            {isEditingAccount ? (
              <AccountDetailEditForm
                userDetails={userDetails}
                onCancel={() => setIsEditingAccount(false)}
                onSave={(payload) => {
                  dispatch(updateEmployee(payload.id, payload));
                  userDetails.employee_salary = {
                    ...userDetails.employee_salary,
                    ...payload.employee_salary
                  };
                  setIsEditingAccount(false);
                }}
              />
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Bank Name:</strong>{" "}
                    {userDetails?.employee_salary?.bank_name || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Bank Branch:</strong>{" "}
                    {userDetails?.employee_salary?.bank_branch || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Account Number:</strong>{" "}
                    {userDetails?.employee_salary?.account_number || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>PF Number:</strong>{" "}
                    {userDetails?.employee_salary?.pf_number || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>PAN Number:</strong>{" "}
                    {userDetails?.employee_salary?.pan_number || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>ESI Number:</strong>{" "}
                    {userDetails?.employee_salary?.esi_number || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>IFSC Code:</strong>{" "}
                    {userDetails?.employee_salary?.ifsc_code || "N/A"}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Box>
        )}

        {tabIndex === 5 && (
          <Box sx={{ ml: 2 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography variant="h6">Leave Detail</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Paid Leave:</strong>{" "}
                  {userDetails?.leave_balance?.paid_leave_balance || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Unpaid Leave:</strong>{" "}
                  {userDetails?.leave_balance?.unpaid_leave_balance || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Casual Leave:</strong>{" "}
                  {userDetails?.leave_balance?.casual_leave_balance || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Sick Leave:</strong>{" "}
                  {userDetails?.leave_balance?.sick_leave_balance || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Maternity Leave:</strong>{" "}
                  {userDetails?.leave_balance?.maternity_leave_balance || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Marriage Leave:</strong>{" "}
                  {userDetails?.leave_balance?.marriage_leave_balance || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Comp Off Leave:</strong>{" "}
                  {userDetails?.leave_balance?.compensatory_off_leave_balance ||
                    "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Overtime Eligible:</strong>{" "}
                  {userDetails?.leave_balance?.overtime_eligible
                    ? "Yes"
                    : "No" || "N/A"}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EditProfileDialog;
